/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, theme } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import {
  StatusCards,
  useUpdateStatusFilter,
} from "~/views/resources/ResourceUpdateStatus";
import { ResourcesTable } from "./components";

export function ResourcesPage() {
  const breadcrumbsLabels = [
    { label: "Dashboard", uri: "/" },
    { label: "Resources", uri: ROUTES.resources.index },
  ];

  const { activeStatuses, handleStatusClick } = useUpdateStatusFilter();

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Resources"
            customBreadcrumbs={breadcrumbsLabels}
          />
        </Col>
      </Row>
      <Row>
        <Col style={{ marginBottom: theme.spacing.spacing02 }}>
          <Box>
            <StatusCards
              activeStatuses={activeStatuses}
              onClick={handleStatusClick}
            />
          </Box>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <ResourcesTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
